const cookie = {
    get(dom, key) {
        if (dom && dom.cookie) {
            const matches = dom.cookie.match("(^|;) ?" + key + "=([^;$]*)");

            if (matches) {
                return matches[2];
            }
        }

        return null;
    },
};

export default cookie;
